import SeoMeta from '../components/SeoMeta';
import {
  CampaignEstate,
  CampaignInquiry,
  CampaignInvestment,
} from '../components/WeddingAvailabilitySections';

const heroImage = 'https://ik.imagekit.io/aeu02xvjgn/Padua-Hills-Weddings-Lauren-and-DJ-168.jpg?tr=w-1800,q-85,f-auto';
const heroImageSrcSet = [
  'https://ik.imagekit.io/aeu02xvjgn/Padua-Hills-Weddings-Lauren-and-DJ-168.jpg?tr=w-640,q-85,f-auto 640w',
  'https://ik.imagekit.io/aeu02xvjgn/Padua-Hills-Weddings-Lauren-and-DJ-168.jpg?tr=w-960,q-85,f-auto 960w',
  'https://ik.imagekit.io/aeu02xvjgn/Padua-Hills-Weddings-Lauren-and-DJ-168.jpg?tr=w-1280,q-85,f-auto 1280w',
  'https://ik.imagekit.io/aeu02xvjgn/Padua-Hills-Weddings-Lauren-and-DJ-168.jpg?tr=w-1800,q-85,f-auto 1800w',
].join(', ');

export default function WeddingAvailability() {
  return (
    <main className="bg-[#FCFAF6] text-[#2F2B28]">
      <SeoMeta
        title="Wedding Availability in Claremont | Padua Weddings"
        description="Explore a Spanish Revival wedding estate in Claremont, California. Review published minimums and ask the Padua Weddings team about your date and a private tour."
        image={heroImage}
      />

      <header className="absolute z-10 w-full px-5 py-5 text-[#FCFAF6] sm:px-8">
        <a href="#top" className="font-serif text-xl tracking-wide focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 sm:text-2xl">
          Padua Weddings
        </a>
        <nav aria-label="Campaign sections" className="mt-3 flex gap-5 text-[10px] font-semibold uppercase tracking-[0.16em] sm:absolute sm:right-8 sm:top-6 sm:mt-0 sm:gap-7">
          <a className="underline-offset-4 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4" href="#campaign-estate">Estate</a>
          <a className="underline-offset-4 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4" href="#campaign-investment">Investment</a>
          <a className="underline-offset-4 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4" href="#campaign-inquiry">Inquiry</a>
        </nav>
      </header>

      <section id="top" className="relative isolate flex min-h-[620px] items-center overflow-hidden bg-[#2F2B28] px-6 pb-20 pt-36 sm:min-h-[680px] sm:px-10 lg:min-h-[720px]">
        <img
          src={heroImage}
          srcSet={heroImageSrcSet}
          sizes="100vw"
          alt="Wedding celebration at Padua Hills Theatre in Claremont"
          width="1600"
          height="1067"
          fetchPriority="high"
          decoding="async"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#2F2B28]/90 via-[#2F2B28]/55 to-[#2F2B28]/15" />
        <div className="relative mx-auto w-full max-w-6xl">
          <p className="mb-5 text-xs font-semibold uppercase tracking-[0.26em] text-[#E0D5C6]">Padua Hills Theatre · Claremont, California</p>
          <h1 className="max-w-3xl font-serif text-4xl font-light leading-[1.08] text-[#FCFAF6] sm:text-5xl lg:text-7xl">
            A Spanish Revival Wedding Estate in Claremont.
          </h1>
          <p className="mt-6 max-w-xl text-base leading-7 text-[#FCFAF6]/90 sm:text-lg">
            Outdoor ceremony, indoor reception and chef-driven menus across a distinctive Claremont estate.
          </p>
          <div className="mt-9 flex flex-col gap-3 sm:flex-row">
            <a className="inline-flex min-h-12 items-center justify-center bg-[#6E7451] px-7 py-3 text-center text-xs font-semibold uppercase tracking-[0.16em] text-white hover:bg-[#596043] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white" href="#campaign-inquiry">
              Check Your Date
            </a>
            <a className="inline-flex min-h-12 items-center justify-center border border-[#FCFAF6]/80 bg-[#2F2B28]/20 px-7 py-3 text-center text-xs font-semibold uppercase tracking-[0.16em] text-[#FCFAF6] hover:bg-[#FCFAF6]/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white" href="#campaign-estate">
              Explore the Estate
            </a>
          </div>
        </div>
      </section>

      <section className="border-b border-[#D9CCBA] bg-[#FCFAF6] px-6 py-8 sm:py-10">
        <ul className="mx-auto grid max-w-6xl gap-4 text-sm font-medium text-[#2F2B28] sm:grid-cols-3 sm:gap-8">
          <li className="border-l-2 border-[#6E7451] pl-4">Outdoor ceremony</li>
          <li className="border-l-2 border-[#6E7451] pl-4">Indoor reception</li>
          <li className="border-l-2 border-[#6E7451] pl-4">Chef-driven menus</li>
        </ul>
      </section>

      <CampaignEstate />
      <CampaignInvestment />
      <CampaignInquiry />
    </main>
  );
}